import React from 'react';
import './chapters.scss';

function Intro() {
  return (
    <section className="chapters chapters-intro">
      <h2>
        The future of the automobile isn’t speed—it’s silicon—and Intel is leading the race to a{' '}
        <span className="linebreak">smarter vehicle.</span>
      </h2>
      <div className="chapters__copy chapters__copy--intro">
        <p>
          You’ve probably seen the memes: videos of kids seeing something for the first time that
          was instantly recognizable in your youth—an old VHS tape or a rotary telephone—and asking,
          “What is <span className="italic">that</span>?” Our shock of having traversed decades in a
          flash of memory is met by their shock at learning the answer. For them, movies live in
          streaming software on the TV, not in a clunky plastic box. A phone has a small glass
          screen that fits in your pocket and runs software that plays music and games and makes
          video calls.
        </p>
        <p>
          But if you were to show these same kids a picture of a car from generations past, the meme
          would not work. It’s uncanny that even though cars have become faster, more efficient, and
          safer, the form and function of our beloved vehicles have remained largely unchanged over
          the past 100 years.
        </p>
        <p>
          <span className="italic">All that is about to change.</span>
        </p>
        <p>
          If the cars of the past needed to get people from Point A to Point B reliably, safely, and
          comfortably, the cars of the future need to do all that and be powered electrically,
          embrace connectivity, deliver an entirely digital experience, and be part of a larger
          mobility as a service (MaaS) network. Engineered around a new generation of powerful
          automotive processors, the car of the future might be outwardly recognizable as a car,
          under the hood, it will be more like a computer on wheels.
        </p>
        <p>
          This is a giant shift for the industry, and there are clear hurdles to overcome—but
          automakers have found help from tech partners such as Intel.
        </p>
      </div>
    </section>
  );
}

export default Intro;
